export default "__VITE_ASSET__BKYDgfZB__"